module.exports = __webpack_public_path__ + "static/img/guide_2.f2e03a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/guide_2.png
// module id = wUvN
// module chunks = 28